export const canCopySpecDescription = () => () => {
    return function (nodes) {
        if (1 !== nodes.size) {
            return []
        }

        if ('_LSI_MAP' !== this.data.mapTypeCode) {
            return []
        }

        const [node] = nodes

        if (
            node !== this.root ||
            'LSI' !== node.data.bizNodeType
        ) {
            return []
        }

        return [node]
    }
}

export const copySpecDescription = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.actions.copySpecDescription(nodes)
        )
    }
}
